import { render, staticRenderFns } from "./WorkspaceCol.vue?vue&type=template&id=74183587&"
import script from "./WorkspaceCol.vue?vue&type=script&lang=js&"
export * from "./WorkspaceCol.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceCol.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports